import React, { Component } from 'react';
import moment from 'moment';
import networkList from '../../../constants/networkList';
const {homepage} = networkList;
class PrintClearance extends Component {

    constructor(props) {
        super(props);
        this.state = {
            'printData': {}
        }
    }

    componentDidMount() {
        window.scrollTo({
            top: 50,
            left: 0,
            behavior: 'smooth'
        });
    }
    print = () => {
        document.getElementById("myH1").style.margin = "-130px 0px 0px 0px";
        window.print();
        document.getElementById("myH1").style.margin = "0px";
    }
    cancelPrint(){
        this.props.cancel()
    }
    render() {
        let { printData, user_data } = this.state;
        return (
            <div className="fc-patient-copy">
                <div className="p-4 bg-white" id="myH1">
                    <div className="clearfix pt-5">
                        <img src={homepage+"/assets/images/logo-black.png"} alt="Kims" className="float-left"></img>
                        <p className="float-right align-middle pb-0 my-2 ">KIMS-K/BILL/F/B/04</p>
                    </div>

                    <div>
                        <h1 className="text-p-bold text-center text-uppercase py-4">Clearance</h1>
                    </div>
                    <div className="mx-auto w-50">
                        <div className="row m-0 pb-3 border">
                            <div className="col-12">
                                <div className="d-inline-flex">
                                    <span className="w-label">Date</span>
                                    <span className="w-100">: 2020-12-10</span>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="d-inline-flex">
                                    <span className="w-label">Patient Name</span>
                                    <span className="w-100">: K SATYANARAYANA</span>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="d-inline-flex">
                                    <span className="w-label">IP Number</span>
                                    <span className="w-100">: IP123456789</span>
                                </div>
                            </div>
                        </div>
                        <div className="row m-0 pb-3 border">
                            <div className="col-12">
                                <div className="d-inline-flex">
                                    <span className="w-label">Bill Amount</span>
                                    <span className="w-100">: 200000</span>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="d-inline-flex">
                                    <span className="w-label">Approved Amount</span>
                                    <span className="w-100">: 220000</span>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="d-inline-flex">
                                    <span className="w-label">Insurance Tpa Name</span>
                                    <span className="w-100">: Family Health Plan Insurance TPA Limited</span>
                                </div>
                            </div>
                        </div>
                        <div className="row m-0 pb-3 border">
                            <div className="col-12">
                                <div className="d-inline-flex">
                                    <span className="w-label">Copayment</span>
                                    <span className="w-100">: 200000</span>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="d-inline-flex">
                                    <span className="w-label">Difference Amount</span>
                                    <span className="w-100">: 20000</span>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="d-inline-flex">
                                    <span className="w-label">NME</span>
                                    <span className="w-100">: 1000</span>
                                </div>
                            </div>
                        </div>
                        <div className="row m-0 pb-3 border">
                            <div className="col-12">
                                <div className="d-inline-flex">
                                    <span className="w-label">Amount</span>
                                    <span className="w-100">: 200000</span>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="d-inline-flex">
                                    <span className="w-label">Less Advance</span>
                                    <span className="w-100">: 2000</span>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="d-inline-flex">
                                    <span className="w-label">To Collect / Refund</span>
                                    <span className="w-100">: 20000</span>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="mx-auto w-50 pb-4">
                        <div className="clearfix pt-5">
                            <span className="float-left">
                                Signature: _______________
                            </span>
                            <span className="float-right">
                                Date: _______________
                            </span>
                        </div>
                        <div className="row justify-content-center p-4 pt-4 position-fixed" style={{'bottom': '8px',left: '40%'}}>
                            <button className="btn btn-success d-print-none text-capitalize" onClick={this.print}>Print</button>
                            <button className="btn btn-success  d-print-none btn-next text-capitalize ml-3" onClick={this.cancelPrint.bind(this)}>cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default PrintClearance;